<template>
  <modal
    name="adjustSessionTimeModal"
    class="adjust-session-time-modal"
    transition="pop-out"
    width="500"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    v-model="isAdjustSessionTimeModalOpen"
  >
    <div class="position-relative modal-outer-container">
      <div class="modal-header border-bottom">
        <div class="ml-3 pl-2 font-weight-bold">Adjust Session Time</div>
        <button class="btn border-0" @click="hide">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>
      <div class="modal-body p-4">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>Start Time</label>
              <VueDatePicker
                v-model="startTime"
                :week-start="0"
                auto-apply
                :ui="{ input: 'form-control' }"
                placeholder="Start Time"
                :input-attrs="{ style: 'font-size: 12px' }"
                :formats="{ input: 'MMM d, yyyy, h:mm a' }"
                :time-config="{ is24: false }"
                :text-input="false"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>End Time</label>
              <VueDatePicker
                v-model="endTime"
                :week-start="0"
                auto-apply
                :ui="{ input: 'form-control' }"
                placeholder="End Time"
                :input-attrs="{ style: 'font-size: 12px' }"
                :formats="{ input: 'MMM d, yyyy h:mm a' }"
                :time-config="{ is24: false }"
                :text-input="false"
              />
            </div>
          </div>
        </div>
        <div class="custom-control custom-checkbox mt-2">
          <input
            type="checkbox"
            v-model="allowOverlap"
            id="adjustTimeAllowOverlap"
            class="custom-control-input"
          />
          <label
            class="custom-control-label text-dark-red"
            for="adjustTimeAllowOverlap"
          >
            Allow Overlapping With Other Sessions
          </label>
        </div>
        <p class="text-muted small mb-0 mt-3">
          <i class="fas fa-info-circle mr-1"></i>
          This will update the start and end time of the selected session.
        </p>
      </div>
      <div class="modal-footer border-top d-flex justify-content-end">
        <button class="btn btn-secondary mr-2" @click="hide" :disabled="saving">
          Cancel
        </button>
        <button
          class="btn btn-theme"
          @click="save"
          :disabled="saving || !isValid"
        >
          <span
            v-if="saving"
            class="spinner-border spinner-border-sm mr-1"
          ></span>
          Save
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import helpers from "@/utils/helpers";
import Swal from "sweetalert2";

export default {
  name: "AdjustSessionTimeModal",

  data() {
    return {
      sessionType: null,
      sessionId: null,
      startTime: "",
      endTime: "",
      allowOverlap: false,
      saving: false,
      isAdjustSessionTimeModalOpen: false,
    };
  },
  computed: {
    isValid() {
      return (
        this.startTime &&
        this.endTime &&
        new Date(this.endTime) > new Date(this.startTime)
      );
    },
  },
  methods: {
    show(session, type) {
      this.sessionType = type;
      this.sessionId = session.id;
      this.startTime = helpers.convertUTCToLocal(session.start_time);
      this.endTime = helpers.convertUTCToLocal(session.end_time);
      this.allowOverlap = false;
      this.saving = false;
      this.isAdjustSessionTimeModalOpen = true;
    },
    hide() {
      this.isAdjustSessionTimeModalOpen = false;
    },
    async save() {
      if (!this.isValid) {
        return;
      }

      this.saving = true;
      const payload = {
        start_time: helpers.convertToTorontoUTC(this.startTime),
        end_time: helpers.convertToTorontoUTC(this.endTime),
        allow_overlap: this.allowOverlap,
      };

      try {
        let url =
          this.sessionType === "1:1"
            ? `appointments/${this.sessionId}/adjust-time`
            : `group-sessions/${this.sessionId}/adjust-time`;

        const res = await this.$http.put(url, payload);
        const saved = res.data.data;

        this.$emit("saved", {
          type: this.sessionType,
          id: this.sessionId,
          start_time: saved.start_time,
          end_time: saved.end_time,
        });
        this.hide();
      } catch (err) {
        const message =
          err?.data?.message ||
          err?.response?.data?.message ||
          "Something went wrong. Please try again.";
        Swal.fire({
          title: "Error",
          text: message,
          icon: "error",
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss">
.adjust-session-time-modal {
  .ccc-modal-content {
    background-color: #fff;
    overflow: visible !important;
    .modal-body {
      overflow: visible;
    }
  }
}
</style>
